export default {
  "pages": [
    {
      "name": "page1",
      "elements": [
        {
          "type": "radiogroup",
          "name": "question1",
          "isRequired": "true",
          "title": "Welche Antwort trifft am ehesten auf dich zu?",
          "choices": [
            {
              "value": 5,
              "text": "Ich beteilige mich an der Entscheidungsfindung. Die finale Entscheidung überlasse ich jedoch meinem Vorgesetzten."
            },
            {
              "value": 15,
              "text": "Ich lasse mich gerne überzeugen – die Mehrheit entscheidet."
            },
            {
              "value": 10,
              "text": "Ich finde es wichtig, dass alle Teammitglieder hinter einer zu treffenden Entscheidung stehen."
            },
            {
              "value": 20,
              "text": "Am Ende müssen nicht alle Teammitglieder einer Meinung sein, aber die finale Entscheidung respektieren."
            }
          ]
        }
      ],
      "title": "Wie triffst du gerne Entscheidungen?"
    },
    {
      "name": "page2",
      "title": "Was war Deine größte berufliche Herausforderung? Wie hast Du diese gemeistert?\n",
      "elements": [
        {
          "type": "comment",
          "name": "big5Text",
          "title": "Bitte schreibe mindestens 100 Wörter, um ein möglichst genaues Testergebnis zu erhalten.",
          "isRequired": "true",
          "validators": [
            {
              "type": "expression",
              "text": "Die Mindestwortanzahl ist noch nicht erreicht.",
              "expression": "WordCountMinValidator({big5Text}, 100)"
            }
          ],
          "cols": 14,
          "rows": 8,
          "autoGrow": "true"
        }
      ]
    },
    {
      "name": "page3",
      "elements": [
        {
          "type": "rating",
          "name": "firstQuestion",
          "titleLocation": "hidden",
          "isRequired": "true",
          "rateValues": [
            {
              "value": [
                2,
                1
              ],
              "text": " "
            },
            {
              "value": [
                1,
                2
              ],
              "text": " "
            },
            {
              "value": [
                0.5,
                3
              ],
              "text": " "
            },
            {
              "value": [
                -0.5,
                6
              ],
              "text": " "
            },
            {
              "value": [
                -1,
                5
              ],
              "text": " "
            },
            {
              "value": [
                -2,
                4
              ],
              "text": " "
            }
          ],
          "rateMax": 6,
          "minRateDescription": "Mir ist es wichtig, traditionelle Werte und Überzeugungen aufrecht zu erhalten.",
          "maxRateDescription": "No risk - no fun. Ich möchte Neues erleben!"
        },
        {
          "type": "rating",
          "name": "secondQuestion",
          "titleLocation": "hidden",
          "isRequired": "true",
          "rateValues": [
            {
              "value": [
                2,
                5
              ],
              "text": " "
            },
            {
              "value": [
                1,
                6
              ],
              "text": " "
            },
            {
              "value": [
                0.5,
                4
              ],
              "text": " "
            },
            {
              "value": [
                -0.5,
                3
              ],
              "text": " "
            },
            {
              "value": [
                -1,
                2
              ],
              "text": " "
            },
            {
              "value": [
                -2,
                1
              ],
              "text": " "
            }
          ],
          "rateMax": 6,
          "minRateDescription": "Mir ist es viel wert, nachhaltig zu leben und auf die Umwelt zu achten.",
          "maxRateDescription": "Man muss sich ab und zu auch mal etwas gönnen!"
        },
        {
          "type": "rating",
          "name": "thirdQuestion",
          "titleLocation": "hidden",
          "isRequired": "true",
          "rateValues": [
            {
              "value": [
                2,
                4
              ],
              "text": " "
            },
            {
              "value": [
                1,
                5
              ],
              "text": " "
            },
            {
              "value": [
                0.5,
                6
              ],
              "text": " "
            },
            {
              "value": [
                -0.5,
                3
              ],
              "text": " "
            },
            {
              "value": [
                -1,
                2
              ],
              "text": " "
            },
            {
              "value": [
                -2,
                1
              ],
              "text": " "
            }
          ],
          "rateMax": 6,
          "minRateDescription": "Ich halte mich an Vorgaben, dann bin ich auf der sicheren Seite.",
          "maxRateDescription": "Mir ist es wichtig, dass meine Kollegen tun, was ich ihnen sage."
        },
        {
          "type": "rating",
          "name": "fourthQuestion",
          "titleLocation": "hidden",
          "isRequired": "true",
          "rateValues": [
            {
              "value": [
                2,
                4
              ],
              "text": " "
            },
            {
              "value": [
                1,
                5
              ],
              "text": " "
            },
            {
              "value": [
                0.5,
                6
              ],
              "text": " "
            },
            {
              "value": [
                -0.5,
                3
              ],
              "text": " "
            },
            {
              "value": [
                -1,
                2
              ],
              "text": " "
            },
            {
              "value": [
                -2,
                1
              ],
              "text": " "
            }
          ],
          "rateMax": 6,
          "minRateDescription": "Es ist mir wichtig, Leistung zu zeigen. Erfolg ist kein Zufall.",
          "maxRateDescription": "Ich vermeide alles, was meine Sicherheit gefährden könnte."
        },
        {
          "type": "rating",
          "name": "fifthQuestion",
          "titleLocation": "hidden",
          "isRequired": "true",
          "rateValues": [
            {
              "value": [
                2,
                5
              ],
              "text": " "
            },
            {
              "value": [
                1,
                6
              ],
              "text": " "
            },
            {
              "value": [
                0.5,
                4
              ],
              "text": " "
            },
            {
              "value": [
                -0.5,
                3
              ],
              "text": " "
            },
            {
              "value": [
                -1,
                2
              ],
              "text": " "
            },
            {
              "value": [
                -2,
                1
              ],
              "text": " "
            }
          ],
          "rateMax": 6,
          "minRateDescription": "Ich möchte meine Arbeit eigenständig organisieren und umsetzen.",
          "maxRateDescription": "Ich richte mich oft nach meinen Teamkollegen.",
          "title": "Welcher Aussage stimmst du eher zu?"
        }
      ],
      "title": "Welcher Aussage stimmst du eher zu?",
      "description": "Kreuze ganz links oder ganz rechts an, wenn du entweder der einen oder der anderen Aussage zustimmst; kreuze eher mittig an, wenn beides auf dich zutrifft."
    },
    {
      "name": "page4",
      "elements": [
        {
          "type": "rating",
          "name": "sixthQuestion",
          "titleLocation": "hidden",
          "isRequired": "true",
          "rateValues": [
            {
              "value": [
                2,
                4
              ],
              "text": " "
            },
            {
              "value": [
                1,
                5
              ],
              "text": " "
            },
            {
              "value": [
                0.5,
                6
              ],
              "text": " "
            },
            {
              "value": [
                -0.5,
                3
              ],
              "text": " "
            },
            {
              "value": [
                -1,
                2
              ],
              "text": " "
            },
            {
              "value": [
                -2,
                1
              ],
              "text": " "
            }
          ],
          "rateMax": 6,
          "minRateDescription": "Ich mag es, wichtige Entscheidungen zu treffen und Einfluss zu haben.",
          "maxRateDescription": "Es ist mir wichtig, bescheiden zu sein."
        },
        {
          "type": "rating",
          "name": "seventhQuestion",
          "titleLocation": "hidden",
          "isRequired": "true",
          "rateValues": [
            {
              "value": [
                2,
                5
              ],
              "text": " "
            },
            {
              "value": [
                1,
                6
              ],
              "text": " "
            },
            {
              "value": [
                0.5,
                5
              ],
              "text": " "
            },
            {
              "value": [
                -0.5,
                4
              ],
              "text": " "
            },
            {
              "value": [
                -1,
                2
              ],
              "text": " "
            },
            {
              "value": [
                -2,
                2
              ],
              "text": " "
            }
          ],
          "rateMax": 6,
          "minRateDescription": "Man lebt nicht, um zu arbeiten, man arbeitet, um zu leben!",
          "maxRateDescription": "Mir sind Fortschritt und dessen Anerkennung sehr wichtig."
        },
        {
          "type": "rating",
          "name": "eighthQuestion",
          "titleLocation": "hidden",
          "isRequired": "true",
          "rateValues": [
            {
              "value": [
                2,
                5
              ],
              "text": " "
            },
            {
              "value": [
                1,
                6
              ],
              "text": " "
            },
            {
              "value": [
                0.5,
                4
              ],
              "text": " "
            },
            {
              "value": [
                -0.5,
                3
              ],
              "text": " "
            },
            {
              "value": [
                -1,
                2
              ],
              "text": " "
            },
            {
              "value": [
                -2,
                1
              ],
              "text": " "
            }
          ],
          "rateMax": 6,
          "minRateDescription": "Ich zögere nicht lange, wenn es um Abenteuer geht. Ich mag Adrenalin-Schübe.",
          "maxRateDescription": "Es fällt mir schwer, wirklich kreativ zu sein. Ich bleibe lieber beim Gewohnten!"
        },
        {
          "type": "rating",
          "name": "ninthQuestion",
          "titleLocation": "hidden",
          "isRequired": "true",
          "rateValues": [
            {
              "value": [
                2,
                4
              ],
              "text": " "
            },
            {
              "value": [
                1,
                6
              ],
              "text": " "
            },
            {
              "value": [
                0.5,
                5
              ],
              "text": " "
            },
            {
              "value": [
                -0.5,
                3
              ],
              "text": " "
            },
            {
              "value": [
                -1,
                2
              ],
              "text": " "
            },
            {
              "value": [
                -2,
                1
              ],
              "text": " "
            }
          ],
          "rateMax": 6,
          "minRateDescription": "Ich schätze es, arbeiten zu können, wie ich will. Ich bin ein Freigeist!",
          "maxRateDescription": "Mir ist es wichtig, dass jeder Mensch auf der Welt die gleichen Chancen im Leben hat."
        },
        {
          "type": "rating",
          "name": "tenthQuestion",
          "titleLocation": "hidden",
          "isRequired": "true",
          "rateValues": [
            {
              "value": [
                2,
                4
              ],
              "text": " "
            },
            {
              "value": [
                1,
                6
              ],
              "text": " "
            },
            {
              "value": [
                0.5,
                5
              ],
              "text": " "
            },
            {
              "value": [
                -0.5,
                2
              ],
              "text": " "
            },
            {
              "value": [
                -1,
                2
              ],
              "text": " "
            },
            {
              "value": [
                -2,
                2
              ],
              "text": " "
            }
          ],
          "rateMax": 6,
          "minRateDescription": "Ich möchte mich auf meine Kolleg:innen verlassen können.",
          "maxRateDescription": "Ich bin kein großer Fan von Ritualen und Routinen am Arbeitsplatz."
        }
      ],
      "title": "Welcher Aussage stimmst du eher zu?",
      "description": "Kreuze ganz links oder ganz rechts an, wenn Du entweder der einen oder der anderen Aussage zustimmst; kreuze eher mittig an, wenn beides auf Dich zutrifft."
    },
    {
      "name": "page5",
      "title": "Wie gibst du anderen gerne Feedback?",
      "elements": [
        {
          "type": "radiogroup",
          "name": "question2",
          "isRequired": "true",
          "title": "Welche Antwort trifft am ehesten auf dich zu?",
          "choices": [
            {
              "value": 20,
              "text": "Proaktiv, aber vorsichtig und positiv verpackt."
            },
            {
              "value": 15,
              "text": "Proaktiv und dabei offen und unverblümt."
            },
            {
              "value": 5,
              "text": "Ich vermeide es, andere zu kritisieren."
            },
            {
              "value": 10,
              "text": "Nur auf Nachfrage, aber ehrlich und direkt."
            }
          ]
        }
      ]
    }
  ],
  "showQuestionNumbers": "off",
  "locale": "de",
};
